import styled from 'styled-components/macro'

const StyledLineBreak = styled.hr`
  border: 1px solid ${({ theme }) => theme.palette.lightgray.main};
  margin-top: 0;
`

export default StyledLineBreak
